module.exports = __webpack_public_path__ + "media/images/character-img-apologizing-5b50beac4e9a401afc2ca0a001ba14ea.png";